var map = {
	"./bg/bg-1": 70,
	"./bg/bg-1.jpg": 70,
	"./bg/bg-2": 71,
	"./bg/bg-2.jpg": 71,
	"./bg/bg-3": 72,
	"./bg/bg-3.jpg": 72,
	"./bg/bg-4": 73,
	"./bg/bg-4.jpg": 73,
	"./bg/bg-5": 74,
	"./bg/bg-5.jpg": 74,
	"./bg/bg-6": 67,
	"./bg/bg-6.jpg": 121,
	"./bg/bg-6.png": 67,
	"./bg/bg-7": 75,
	"./bg/bg-7.jpg": 75,
	"./bg/notification_bg": 76,
	"./bg/notification_bg.jpg": 76,
	"./bg/quick_actions_bg": 77,
	"./bg/quick_actions_bg.jpg": 77,
	"./bg/user_profile_bg": 78,
	"./bg/user_profile_bg.jpg": 78,
	"./favicon": 79,
	"./favicon.png": 79,
	"./flags/001-austria": 80,
	"./flags/001-austria.svg": 80,
	"./flags/002-belgium": 81,
	"./flags/002-belgium.svg": 81,
	"./flags/003-switzerland": 82,
	"./flags/003-switzerland.svg": 82,
	"./flags/004-indonesia": 83,
	"./flags/004-indonesia.svg": 83,
	"./flags/005-portugal": 84,
	"./flags/005-portugal.svg": 84,
	"./flags/006-turkey": 85,
	"./flags/006-turkey.svg": 85,
	"./flags/007-malasya": 86,
	"./flags/007-malasya.svg": 86,
	"./flags/008-saudi-arabia": 87,
	"./flags/008-saudi-arabia.svg": 87,
	"./flags/009-australia": 88,
	"./flags/009-australia.svg": 88,
	"./flags/010-india": 89,
	"./flags/010-india.svg": 89,
	"./flags/011-brazil": 90,
	"./flags/011-brazil.svg": 90,
	"./flags/012-uk": 91,
	"./flags/012-uk.svg": 91,
	"./flags/013-russia": 92,
	"./flags/013-russia.svg": 92,
	"./flags/014-japan": 93,
	"./flags/014-japan.svg": 93,
	"./flags/015-china": 94,
	"./flags/015-china.svg": 94,
	"./flags/016-spain": 95,
	"./flags/016-spain.svg": 95,
	"./flags/017-germany": 96,
	"./flags/017-germany.svg": 96,
	"./flags/018-south-korea": 97,
	"./flags/018-south-korea.svg": 97,
	"./flags/019-france": 98,
	"./flags/019-france.svg": 98,
	"./flags/020-flag": 99,
	"./flags/020-flag.svg": 99,
	"./flags/021-mexico": 100,
	"./flags/021-mexico.svg": 100,
	"./logo": 101,
	"./logo-md": 102,
	"./logo-md.png": 102,
	"./logo-sm": 103,
	"./logo-sm.png": 103,
	"./logo.png": 101,
	"./missing": 104,
	"./missing.png": 104,
	"./result_test": 23,
	"./result_test.png": 23,
	"./shield_black": 105,
	"./shield_black.png": 105,
	"./shield_color": 106,
	"./shield_color.png": 106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 120;